import React from 'react';
import { Header } from '../../features/header/Header';
import styled from 'styled-components';

import { Container, Table } from 'reactstrap';

const FieldName = styled.th`
  width: 25%;
`;

function FepLinearFieldSpecPage() {
  return (
    <>
      <Header />
      <Container>
        <h2 className="mb-4">FX Forwards Required File Format</h2>
        <h3 className="mb-4">General File Format</h3>
        <p>
          Trades should be uploaded in comma-delimited csv files with all
          timestamps in ISO 8601 Date and Time format.
        </p>
        <p>
          For fields denoted with a *, please refer to the caveats section for
          additional details.
        </p>
        <h3 className="mb-4">Required Fields</h3>
        <h4 className="mb-4">Option #1</h4>
        <Table>
          <thead>
            <tr>
              <FieldName>Field Name</FieldName>
              <th>Alternative Field Names</th>
              <th>Examples</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Ccy_Pair*</td>
              <td>CurrencyPair</td>
              <td>GBP, USD, GBPUSD</td>
            </tr>
            <tr>
              <td>Trade_DateTime</td>
              <td>ExecutionDateTime, DealDateTime</td>
              <td>2015-08-29T11:22:09.815479+01:00</td>
            </tr>
            <tr>
              <td>Tenor*</td>
              <td>Tnr</td>
              <td>SPT, TOM, SPTTOM</td>
            </tr>
            <tr>
              <td>Side</td>
              <td>SideString, SideStr</td>
              <td>B, S, Buy, Sell</td>
            </tr>
            <tr>
              <td>Notional_Amount</td>
              <td>Trade_Amount, Deal_Amount, Trade_Size, Deal_Size</td>
              <td>2500000</td>
            </tr>
            <tr>
              <td>Instrument_Type</td>
              <td>InstrumentType, Component_Typology, ComponentTypology</td>
              <td>Spot, Outright, NDF</td>
            </tr>
            <tr>
              <td>Contract_Type</td>
              <td>ContractType, Contract_Typology, ContractTypology</td>
              <td>Spot, FX Swap, Outright, NDF, NDF FX Swap</td>
            </tr>
            <tr>
              <td>Price*</td>
              <td>Trade_Price, Execution_Price, Deal_Price, Rate</td>
              <td>97.25, 104.8565</td>
            </tr>
          </tbody>
          <h4 className="mb-4">Option #2</h4>
        </Table>
        <Table>
          <thead>
            <tr>
              <FieldName>Field Name</FieldName>
              <th>Alternative Field Names</th>
              <th>Examples</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Ccy_Pair*</td>
              <td>CurrencyPair, CcyPair</td>
              <td>GBP, USD, GBPUSD</td>
            </tr>
            <tr>
              <td>Trade_DateTime</td>
              <td>ExecutionDateTime, DealDateTime, TradeDateTime</td>
              <td>XS1472483772, US92857WBJ80</td>
            </tr>
            <tr>
              <td>Value_Date</td>
              <td>Start_Date, ValDate</td>
              <td>2015-08-30</td>
            </tr>
            <tr>
              <td>Maturity_Date*</td>
              <td>MatDate, SettlementDate</td>
              <td>2015-08-30</td>
            </tr>
            <tr>
              <td>Side</td>
              <td>Side_String, SideStr</td>
              <td>B, S, Buy, Sell</td>
            </tr>
            <tr>
              <td>Notional_Amount</td>
              <td>Trade_Amount, Deal_Amount, Trade_Size, Deal_Size</td>
              <td>2500000</td>
            </tr>
            <tr>
              <td>Instrument_Type</td>
              <td>InstrumentType, Component_Typology, ComponentTypology</td>
              <td>Spot, Outright, NDF</td>
            </tr>
            <tr>
              <td>Contract_Type</td>
              <td>ContractType, Contract_Typology, ContractTypology</td>
              <td>Spot, FX Swap, Outright, NDF, NDF FX Swap</td>
            </tr>
            <tr>
              <td>Price*</td>
              <td>Trade_Price, Execution_Price, Deal_Price, Rate</td>
              <td>97.25, 104.8565</td>
            </tr>
          </tbody>
        </Table>
        <h3 className="mb-4">Caveats for Required Fields</h3>
        <p>
          <strong class="title-uppercase">Ccy_Pair:</strong> Can be provided in
          two separate columns called Currency_1 and Currency_2.
        </p>
        <p>
          <strong class="title-uppercase">Tenor:</strong> Can be provided in two
          separate columns called Tenor1 and Tenor2.
        </p>
        <p>
          <strong class="title-uppercase">Price_Type:</strong> There are only
          two acceptable values: Outright or Points.
        </p>
        <p>
          <strong class="title-uppercase">Price:</strong> Rate is also an
          acceptable field name.
        </p>
        <p>
          <strong class="title-uppercase">Maturity_Date:</strong>{' '}
          Settlement_Date is also an acceptable field name.
        </p>
        <h3 className="mb-4">Optional Fields</h3>
        <Table>
          <thead>
            <tr>
              <FieldName>Field Name</FieldName>
              <th> Alternative Field Names</th>
              <th>Examples</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Spot_Price*</td>
              <td>Spt_Price, SptPrice, SpotPrice</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Trade_Id</td>
              <td>TradeID, ID</td>
              <td>7654321, Z9Y8X7</td>
            </tr>
            <tr>
              <td>Account</td>
              <td>Account_Name, AccountName</td>
              <td>ABC, 123</td>
            </tr>
            <tr>
              <td>Benchmark</td>
              <td>Bm, Bench, BMark, Bench_Mark</td>
              <td>1.22687, 141.08</td>
            </tr>
            <tr>
              <td>Contract_Id</td>
              <td>ContractId</td>
              <td>A12345</td>
            </tr>
            <tr>
              <td>CounterParty</td>
              <td>CP, CPTY</td>
              <td>ABC12345</td>
            </tr>
            <tr>
              <td>Cover_Price</td>
              <td>CoverPrice</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Custom_Benchmark_1*</td>
              <td>CustomBenchmark1, Custom_Benchmark1</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Custom_Benchmark_2*</td>
              <td>CustomBenchmark2, Custom_Benchmark2</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Custom_Benchmark_3*</td>
              <td>CustomBenchmark3, Custom_Benchmark3</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Custom_Benchmark_4*</td>
              <td>CustomBenchmark4, Custom_Benchmark4</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Custom_1</td>
              <td>Custom_1</td>
              <td>2022-01-10, 2023-3-5</td>
            </tr>
            <tr>
              <td>Custom_2</td>
              <td>Custom_2</td>
              <td>2021-09-01T05:31:00Z</td>
            </tr>
            <tr>
              <td>Custom_3</td>
              <td>Custom_3</td>
              <td>Notes, Extra information</td>
            </tr>
            <tr>
              <td>Deal_Type</td>
              <td>DealType</td>
              <td>MKT, GTC, LMT</td>
            </tr>
            <tr>
              <td>Description</td>
              <td>Desc</td>
              <td>ABC123</td>
            </tr>
            <tr>
              <td>Desk_Location</td>
              <td>Location, Desk, Trade_Desk</td>
              <td>NYC, LON, SING, HK</td>
            </tr>
            <tr>
              <td>Explicit_Cost</td>
              <td>Cost, ExplicitCost</td>
              <td>3.75, 0.25</td>
            </tr>
            <tr>
              <td>Event_Type</td>
              <td>EventType</td>
              <td>Rebalance, News, Announcement</td>
            </tr>
            <tr>
              <td>Forward_Points</td>
              <td>FwdPoints, FwdPts, Points</td>
              <td>0.555, -12.07167</td>
            </tr>
            <tr>
              <td>Forward_Start_Tenor</td>
              <td>ForwardStartTenor</td>
              <td>TDY, SPT, TOM</td>
            </tr>
            <tr>
              <td>Fund*</td>
              <td>Fund_Type</td>
              <td>Flagship, XYZ</td>
            </tr>
            <tr>
              <td>Instructions</td>
              <td>Instructions</td>
              <td>Discretion, Market</td>
            </tr>
            <tr>
              <td>Legal_Entity</td>
              <td>Entity, ENTITY, LEGAL_ENTITY</td>
              <td>Client-specific codes (e.g. LE_1, LE_2)</td>
            </tr>
            <tr>
              <td>Price_Type*</td>
              <td>PriceType</td>
              <td>
                Outright, O, Points, Pts, Forward Points, Forward Pts, Fwd Pts,
                P, FP
              </td>
            </tr>
            <tr>
              <td>Is_Domestic_Variant</td>
              <td>Domestic_Variant, DomesticVariant, IsDomesticVariant</td>
              <td>TRUE, FALSE</td>
            </tr>
            <tr>
              <td>Is_International_Variant</td>
              <td>IsInternationalVariant, International_Variant</td>
              <td>TRUE, FALSE</td>
            </tr>
            <tr>
              <td>Limit_Price</td>
              <td>Lmt_Price, Lmt</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Notional_Ordered</td>
              <td>NotionalOrdered</td>
              <td>3000000</td>
            </tr>
            <tr>
              <td>Order_Id</td>
              <td>OrderID, RootContract_ID, RootContractId</td>
              <td>A12345</td>
            </tr>
            <tr>
              <td>Order_Size</td>
              <td>OrderSize</td>
              <td>3000000</td>
            </tr>
            <tr>
              <td>Order_Type</td>
              <td>OrderType</td>
              <td>Market, Discretionary</td>
            </tr>
            <tr>
              <td>Other_Id</td>
              <td>OtherId</td>
              <td>Open field</td>
            </tr>
            <tr>
              <td>Platform</td>
              <td>PlatfromVenue, Venue, Plat, Ven</td>
              <td>Platform1, Platform2</td>
            </tr>
            <tr>
              <td>PM</td>
              <td>PortfolioManager</td>
              <td>PM1, PM2</td>
            </tr>
            <tr>
              <td>Portfolio</td>
              <td>Portfolio</td>
              <td>ABC12345</td>
            </tr>
            <tr>
              <td>Security_SubType</td>
              <td>SecuritySubType, Security_Sub_Type</td>
              <td>FWD, NDF</td>
            </tr>
            <tr>
              <td>Security_Type</td>
              <td>SecurityType</td>
              <td>Spot, Forward</td>
            </tr>
            <tr>
              <td>Spot_Delay</td>
              <td>Spt_Delay, SpotDelay</td>
              <td>2</td>
            </tr>
            <tr>
              <td>Status</td>
              <td>Trade_Status, TradeStatus</td>
              <td>Live, Closed</td>
            </tr>
            <tr>
              <td>Strategy*</td>
              <td>StrategyType, Strategy_Type</td>
              <td>Active, Passive</td>
            </tr>
            <tr>
              <td>Time_Zone</td>
              <td>TZ, TimeZone</td>
              <td>GMT+8</td>
            </tr>
            <tr>
              <td>Trade_Type</td>
              <td>TradeType</td>
              <td>Electronic, Voice</td>
            </tr>
            <tr>
              <td>Trader</td>
              <td>TraderName, TraderID, TraderCode</td>
              <td>Trader1, Trader2</td>
            </tr>
          </tbody>
        </Table>
        <h3 className="mb-4">Caveats for Optional Fields</h3>
        <p>
          <strong class="title-uppercase">Spot_Price:</strong> If the user
          provices a spot price, TCA will use the user's spot price over TP
          ICAPs Spot Price.
        </p>
        <p>
          <strong class="title-uppercase">Custom_Benchmark:</strong> If the user
          provides a custom benchmark, the TCA calculations will be performed on
          that benchmark against price. The user will also see all of the other
          benchmarks provided by TCA.
        </p>
        <p>
          <strong class="title-uppercase">Fund:</strong> Fund_Type is also an
          acceptable field name.
        </p>
        <p>
          <strong class="title-uppercase">Strategy</strong> Strategy_Type is
          also an acceptable field name.
        </p>
        <p>
          <strong class="title-uppercase">Price_Type:</strong> If Price_Type is
          not provided TCA will assume the deault price type, which is outright.
        </p>
      </Container>
      <br></br>
      <br></br>
      <br></br>
    </>
  );
}

export default FepLinearFieldSpecPage;
